var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	3155: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	8642: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(4848))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	9203: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5257))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/icons",

	},
	103: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	173: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(203), __webpack_require__.e(103), __webpack_require__.e(148)]).then(() => (() => (__webpack_require__(1115))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/core",

	},
	9762: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3710))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	3238: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5611))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	9743: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.14.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"103": [
		103
	],
	"155": [
		3155
	],
	"203": [
		9203
	],
	"238": [
		3238
	],
	"522": [
		9743
	],
	"642": [
		8642
	],
	"884": [
		173,
		9762,
		3155
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}